<script setup lang="ts">
import type { GalleryColumns } from '../../types'

defineProps<{
  columns: GalleryColumns
}>()
</script>

<template>
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <template v-if="columns === 1">
      <rect x="2.75" y="4.75" width="14.5" height="10.5" rx="1.5" />
    </template>

    <template v-else-if="columns === 2">
      <rect x="2.75" y="4.75" width="6" height="10.5" rx="1.5" />
      <rect x="11.25" y="4.75" width="6" height="10.5" rx="1.5" />
    </template>

    <template v-else>
      <rect x="2.75" y="4.75" width="3.83" height="10.5" rx="1.5" />
      <rect x="8.08" y="4.75" width="3.83" height="10.5" rx="1.5" />
      <rect x="13.42" y="4.75" width="3.83" height="10.5" rx="1.5" />
    </template>
  </svg>
</template>
